<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I am indebted to three people who helped me learn to write: Jane Friedman gave me no-nonsense guidance about the craft of writing. Britta Jensen read my work and marked all over it until I got it right. Kitty Walker guided me through the final revision with patience and wisdom. The mistakes are mine; any excellence is due to their efforts.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?9fca79be